import { isRouteErrorResponse, Link, useRouteError } from 'react-router';

/** Last-resort error boundary for render errors and failed lazy chunks (e.g. after a deployment). */
export function RouteError() {
  const error = useRouteError();
  const chunkFailed = error instanceof Error && /dynamically imported module|Loading chunk/i.test(error.message);
  const message = isRouteErrorResponse(error)
    ? `${error.status} ${error.statusText}`
    : chunkFailed
      ? 'A new version of the website was published. Please reload the page.'
      : 'An unexpected error occurred while displaying this page.';
  if (import.meta.env.DEV) console.error(error);

  return (
    <div role="alert" className="grid min-h-screen place-items-center bg-white px-4 py-16 text-center">
      <div className="max-w-md">
        <p className="font-display text-[22px] font-bold text-ink">Something went wrong</p>
        <p className="mt-2 text-[14px] text-ink-soft">{message}</p>
        <div className="mt-6 flex justify-center gap-3">
          <button type="button" onClick={() => window.location.reload()} className="rounded-full bg-primary px-5 py-2.5 text-[13px] font-semibold text-white">
            Reload page
          </button>
          <Link to="/" className="rounded-full border border-line-strong px-5 py-2.5 text-[13px] font-semibold" reloadDocument>
            Home
          </Link>
        </div>
      </div>
    </div>
  );
}
